module.exports = __webpack_public_path__ + "static/media/bridgeActive.b491a8f1.png";